import { createSlice } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '../../constants';
import api from '../../api';

const loadFromStorage = () => {
  try {
    const token = window.localStorage.getItem(STORAGE_KEYS.BLOG_AUTH_TOKEN);
    const authorRaw = window.localStorage.getItem(STORAGE_KEYS.BLOG_AUTH_AUTHOR);
    if (token) {
      api._token = token;
      return {
        token,
        author: authorRaw ? JSON.parse(authorRaw) : null,
        isLoading: false,
        error: null
      };
    }
  } catch (_) {}
  return { token: null, author: null, isLoading: false, error: null };
};

const initialState = loadFromStorage();

const blogAuthSlice = createSlice({
  name: 'blogAuth',
  initialState,
  reducers: {
    loginStart: (state) => {
      return { ...state, isLoading: true, error: null };
    },
    loginSuccess: (state, action) => {
      const { token, author } = action.payload;
      window.localStorage.setItem(STORAGE_KEYS.BLOG_AUTH_TOKEN, token);
      window.localStorage.setItem(STORAGE_KEYS.BLOG_AUTH_AUTHOR, JSON.stringify(author));
      api._token = token;
      return { token, author, isLoading: false, error: null };
    },
    loginFailure: (state, action) => {
      return { ...state, isLoading: false, error: action.payload };
    },
    logout: () => {
      window.localStorage.removeItem(STORAGE_KEYS.BLOG_AUTH_TOKEN);
      window.localStorage.removeItem(STORAGE_KEYS.BLOG_AUTH_AUTHOR);
      api._token = null;
      return { token: null, author: null, isLoading: false, error: null };
    },
    updateAuthorProfile: (state, action) => {
      const updated = { ...state.author, ...action.payload };
      window.localStorage.setItem(STORAGE_KEYS.BLOG_AUTH_AUTHOR, JSON.stringify(updated));
      return { ...state, author: updated };
    }
  }
});

export const blogAuthActions = blogAuthSlice.actions;
export default blogAuthSlice.reducer;
